import { render, staticRenderFns } from "./postulaciones.vue?vue&type=template&id=60e4c362&lang=html"
import script from "./postulaciones.vue?vue&type=script&lang=js"
export * from "./postulaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports